































































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';

import moment from 'moment';

import Thumb from '@/components/Thumb/index.vue';

import { DEFAULT_USERS } from '@/constant/AvatarsExp';

import {
  Redaction as IRedaction,
  User as IUser,
} from '../../../../interfaces/IRedactionPreview';

@Component({
  components: {
    Thumb,
  },
})
export default class HeaderAThousandRedaction extends Vue {
  @Prop({ required: true }) isActiveCorrection!: boolean;
  @Prop({ required: true }) redaction!: IRedaction;

  setUserAvatar(user: IUser) {
    if (user?.avatar) {
      const photo = (user.avatar.indexOf('http') >= 0 || user.avatar.indexOf('https') >= 0)
        ? user.avatar
        : `https://explicae.com.br/app/${user.avatar}`;

      return photo;
    }

    return DEFAULT_USERS;
  }

  setOptionMenu(value: boolean) {
    this.$emit('setOptionMenu', value);
  }

  formatTimeRedaction(time: number) {
    return moment.utc(time * 1000).format('HH:mm:ss');
  }
}
